import React, { FC, HTMLAttributes, RefCallback, RefObject } from 'react';
// @ts-ignore
import BrowserSymbol from 'svg-baker-runtime/browser-symbol';
// @ts-ignore
import { assign } from 'es6-object-assign';
import { addSpriteSymbol, useIsomorphicLayoutEffect } from '../sprite';
import { SvgIcon } from '../SvgIcon';

const viewBox = '0 0 24 24';
const id = 'skull_outline_24';
const content = '<symbol fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="skull_outline_24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.75 7.85a2.4 2.4 0 100 4.8 2.4 2.4 0 000-4.8zm-.6 2.4a.6.6 0 111.2 0 .6.6 0 01-1.2 0zm4.7 0a2.4 2.4 0 114.8 0 2.4 2.4 0 01-4.8 0zm2.4-.6a.6.6 0 100 1.2.6.6 0 000-1.2z" fill="currentColor" /><path d="M12.9 13.9a.9.9 0 10-1.8 0v.5a.9.9 0 001.8 0v-.5z" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M11.467 3.1h1.066c1.137 0 2.036 0 2.764.05.743.05 1.374.156 1.96.4a5.9 5.9 0 013.194 3.192c.243.588.349 1.218.4 1.96.05.729.05 1.628.05 2.765v.064c0 .673 0 1.223-.032 1.672-.031.464-.099.886-.266 1.29a3.9 3.9 0 01-2.11 2.11 1.37 1.37 0 00-.481.313c-.092.1-.112.175-.112.236V20.1a.9.9 0 01-1.8 0v-1.2h-3.2v1.2a.9.9 0 01-1.8 0v-1.2H7.9v1.2a.9.9 0 01-1.8 0v-2.948c0-.06-.02-.135-.111-.236-.1-.11-.266-.224-.481-.313a3.9 3.9 0 01-2.111-2.11c-.167-.404-.235-.826-.266-1.29-.03-.45-.03-1-.03-1.672v-.064c0-1.137 0-2.036.049-2.764.05-.743.156-1.373.4-1.96a5.9 5.9 0 013.192-3.194c.588-.243 1.218-.349 1.961-.4.728-.049 1.627-.049 2.764-.049zM8.826 4.945c-.652.045-1.063.13-1.395.267a4.1 4.1 0 00-2.219 2.219c-.137.331-.222.743-.266 1.394-.045.66-.046 1.498-.046 2.675 0 .711 0 1.2.027 1.58.025.373.072.576.133.724a2.1 2.1 0 001.136 1.136c.712.295 1.676.98 1.703 2.16h8.202c.027-1.18.992-1.865 1.703-2.16a2.1 2.1 0 001.136-1.136c.061-.148.108-.351.134-.724.026-.38.026-.869.026-1.58 0-1.177 0-2.015-.045-2.675-.045-.651-.13-1.063-.267-1.394a4.1 4.1 0 00-2.219-2.219c-.331-.137-.743-.222-1.394-.267-.66-.045-1.498-.045-2.675-.045h-1c-1.177 0-2.015 0-2.674.045z" fill="currentColor" /></symbol>';

let isMounted = false;
function mountIcon() {
  if (!isMounted) {
    addSpriteSymbol(new BrowserSymbol({
      id: id,
      viewBox: viewBox,
      content: content,
    }));

    isMounted = true;
  }
}

export interface Icon24SkullOutlineProps extends HTMLAttributes<HTMLDivElement> {
  fill?: string;
  width?: number;
  height?: number;
  getRootRef?: RefCallback<HTMLDivElement> | RefObject<HTMLDivElement>;
}

const Icon24SkullOutline: FC<Icon24SkullOutlineProps> = (props) => {
  useIsomorphicLayoutEffect(() => {
    mountIcon();
  }, []);

  return React.createElement(SvgIcon, assign({}, props, {
    viewBox: viewBox,
    id: id,
    width: !isNaN(props.width) ? +props.width : 24,
    height: !isNaN(props.height) ? +props.height : 24,
  }));
};

(Icon24SkullOutline as any).mountIcon = mountIcon;

export default Icon24SkullOutline;
